import {Component, ElementRef, ViewChild} from '@angular/core';
import {MatSlider, MatSliderChange} from '@angular/material/slider';
import {MatCheckboxChange} from '@angular/material/checkbox';


import {DataExchangeService} from '../../../../../../surface3d/src/lib/API/Public/data-exchange.service';


@Component({
    selector: 'burncase-brush-settings',
    templateUrl: './brush-settings.component.html',
    styleUrls: ['./brush-settings.component.css']
})
export class BrushSettingsComponent {

    @ViewChild('slider', {static: true}) slider: ElementRef<MatSlider>;

    // get
    private _regionsClicked = false;

    private _brushHeight = 0.1;

    constructor(public dataExchangeService: DataExchangeService) {
    }

    get regionsClicked(): boolean {
        return this._regionsClicked;
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    /**
     * (De-)activates filter painting based on event
     */
    public filterChanged(event: MatCheckboxChange) {
        this.dataExchangeService.painting.marginalFilter = event.checked;
    }

    public change(event: MatSliderChange) {
        this.dataExchangeService.painting.brushSize = event.value;
        this.dataExchangeService.painting.displayBrushSize(this._brushHeight);
    }

    /**
     * (De-)activates roentgen painting based on event
     */
    public roentgenChanged(event: MatCheckboxChange) {
        this.dataExchangeService.painting.roentgen = event.checked;
    }

    /**
     * (De-)activates region painting based on event
     */
    public regionsChanged(event: MatCheckboxChange) {
        this.dataExchangeService.painting.regions = event.checked;
    }


    /**
     * marks the regions painting checkbox as having been clicked
     */
    public regionsClick() {
        this._regionsClicked = true;
    }

    public inputEnd() {
        this.dataExchangeService.painting.removeBrushSize();
    }


}
